import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Abogado } from 'src/app/model/abogado';
import { Response } from 'src/app/shared/models/response.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from 'src/environments/environment.prod';
import { ReceptorObligatorio } from '../models/receptorobligaorio';

@Injectable({
  providedIn: 'root'
})
export class TipoDenunciaService {

  PHP_API_SERVER = environment.baseUrl;//"http://127.0.0.1:8080";
  // PHP_API_SERVER = "http://portaldedenuncias.azkenservices.com/backend/";
  constructor(private router: Router, private httpClient: HttpClient, private auth: AuthService) { }


  searchComplaintByUserSociety(id_sociedad: string, idioma: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/buscarTipoDenuncia.php`, {
      id_sociedad: id_sociedad,
      idioma: idioma,
    }, options);
  }
  getLastComplaintGroup(id_sociedad: string) {
  const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
  let options = { headers: headers };

  return this.httpClient.post<any>(
    `${this.PHP_API_SERVER}/api/obtenerUltimoGrupoTipoDenuncia.php`,
    { id_sociedad },
    options
    );
  }


  searchReceptorObligatoryByUserSociety(id_usuario: string, id_sociedad: string) : Observable<Response<ReceptorObligatorio[]>> {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post<Response<ReceptorObligatorio[]>>(`${this.PHP_API_SERVER}/api/buscarReceptorObligatorio.php`, {
      id_usuario: id_usuario,
      id_sociedad: id_sociedad,
    }, options);
  }
  searchComplaintBySocietyType(id_sociedad: string, id_tp_denuncia: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/buscarDenunciasPorTipoDenunciaSociedad.php`, {
      id_sociedad: id_sociedad,
      id_tp_denuncia: id_tp_denuncia
    }, options);
  }

  deleteComplaintTypeByUser(id_sociedad: string, id_tp_denuncia: string): Observable<Response<any>> {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post<Response<any>>(`${this.PHP_API_SERVER}/api/eliminarTipoDenuncia.php`, {
      id_sociedad,
      id_tp_denuncia
    }, options);
  }
  updateComplaintByUser(
  id_sociedad: string,
  id_tp_denuncia: string,
  nombre: string,
  descripcion: string,
  id_usuario: string,
  tipo_receptor: string,
  id_gestor: string,
  idioma: string,
  id_gestor_conflicto: string,
  orden: string,
  is_visible: number
): Observable<Response<any>> {

  const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
  let options = { headers: headers };

  return this.httpClient.post<Response<any>>(
    `${this.PHP_API_SERVER}/api/modificarTipoDenuncia.php`,
    {
      id_sociedad,
      id_tp_denuncia,
      nombre,
      descripcion,
      id_usuario,
      tipo_receptor,
      id_gestor,
      idioma,
      id_gestor_conflicto,
      orden,
      is_visible,
    },
    options
  );
}

  addTypeComplaint(id_sociedad: string, id_tp_denuncia: string, nombre: string, descripcion: string, tipo_receptor: string, id_gestor: string, idioma: string, id_gestor_conflicto: string, orden: string): Observable<Response<any>> {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post<Response<any>>(`${this.PHP_API_SERVER}/api/crearTipoDenuncia.php`, {
      id_sociedad: id_sociedad,
      id_tp_denuncia: id_tp_denuncia,
      nombre: nombre,
      descripcion: descripcion,
      tipo_receptor: tipo_receptor,
      id_gestor: id_gestor,
      idioma: idioma,
      id_gestor_conflicto,
      orden,
      is_visible: 1
    }, options);
  }
}
